<template>
    <v-card class="mx-auto " max-width="900">   
      <v-img :src="job.imagePath" class="white--text align-end text-left" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
        height="200px" row>
        <v-card-title  v-text="job.jobName" ></v-card-title>
      </v-img>  
      <v-card-text>
        <v-list dense>
          <v-list-item>
            <v-col cols="3">
              <v-list-item-content class="align-start font-weight-bold">ジョブ名</v-list-item-content>
            </v-col>
            <v-list-item-content class="align-start">{{ job.jobName }}</v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-col cols="3">
              <v-list-item-content class="align-start font-weight-bold">概要</v-list-item-content>
            </v-col>
            <v-list-item-content class="align-start">{{ job.jobOverview }}</v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-col cols="3">
              <v-list-item-content class="align-start font-weight-bold">カテゴリー</v-list-item-content>
            </v-col>
            <v-chip v-for="category in job.categoryList" :key="category.id" color="accent" class="ml-1" small outlined>
              {{ category.name }}
            </v-chip>
          </v-list-item>

          <v-list-item>
            <v-col cols="3">
              <v-list-item-content class="align-start font-weight-bold">現在の継続回数</v-list-item-content>
            </v-col>
            <v-list-item-content class="align-start">{{ jobContinueCount }}</v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-col cols="3">
              <v-list-item-content class="align-start font-weight-bold">目標継続回数</v-list-item-content>
            </v-col>
            <v-list-item-content class="align-start">{{ job.jobTargetContinueCount }}</v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-col cols="3">
              <v-list-item-content class="align-start font-weight-bold">スケジュール</v-list-item-content>
            </v-col>
            <v-list-item-content class="align-start">{{ dispSchedule }}</v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-col cols="3">
              <v-list-item-content class="align-start font-weight-bold">ステータス</v-list-item-content>
            </v-col>
            <v-list-item-content class="align-start">{{ dispJobStatus }}</v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-col cols="3">
              <v-list-item-content class="align-start font-weight-bold">公開設定</v-list-item-content>
            </v-col>
            <v-list-item-content class="align-start">{{ dispJobPublishingSetting }}</v-list-item-content>
          </v-list-item>

        </v-list>
      </v-card-text>
  </v-card>
</template>
<script>
import moment from "moment";
import { mapActions, mapGetters } from 'vuex';
export default {
  components: {
  },
  created(){
    if(!this.$route.params.job_id) return
      this.fetchTheJob(this.$route.params.job_id);
  },
  data () {
    return {
    }
  },
  computed: {
   ...mapGetters('job', ['job']),
   jobContinueCount(){
     return this.job.memberList ? this.job.memberList[0].jobContinueCount : 0
   },
   dispSchedule(){
    moment.locale("ja");
    const dayCount = this.job.dayCount;
    const startDate = this.job.startDate;
    const dayOfWeekList = [];
    let intervalText = null;
    switch(Number(this.job.interval)){
      case 1:
        intervalText = "毎日";
        break;
      case 2:
        intervalText = `${dayCount}日ごと`;
        break;
      case 3:
        this.job.dayOfWeekList.forEach(num => dayOfWeekList.push(moment().isoWeekday(Number(num)).format('dddd')));
        intervalText = `毎週・${dayOfWeekList}`;
        break;
    }
    return `${intervalText}・${startDate}開始`
   },
   dispJobStatus(){
     switch(Number(this.job.jobStatus)){
        case 1:
          return '継続中'
        case 2:
          return '達成'
        case 3:
          return '失敗'
        default:
          return '読み込みできません'
     }
   },
   dispJobPublishingSetting(){
     switch(this.job.jobPublishingSetting){
        case 1:
          return '全体に公開';
        case 2:
          return '友達のみに公開';
        case 3:
          return '非公開';
        default:
          return '読み込みできません'
      }
   }
  },
  methods: {
    ...mapActions('job', ['fetchTheJob'])
  }
}
</script>
